import React from 'react';
import { DialogTitle, DialogContentText, DialogContent, DialogActions, Dialog } from '@mui/material';
import Slide from '@mui/material/Slide';
import { useSelector, useDispatch } from 'react-redux';
import { close } from "./actions/actions";
import Button from '../../components/UI/Button';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

export default function SimpleDialogMessage({ title, description }) {
    const simpleDialogMessage = useSelector(state => state.simpleDialogMessage);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(close());
    };

    return (
        <div>
            <Dialog
                open={simpleDialogMessage}
                slots={{
                    transition: Transition,
                }}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        {description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Ok
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}